import moment from 'moment';

// The account API serialises .NET's DateTime.MinValue instead of null when the
// AI terms have never been accepted, so an unset consent date has to be
// detected by value rather than by absence.
export const AI_CONSENT_UNSET_DATE = '0001-01-01T00:00:00';

// TEMPORARY (2026-09-21): the backend's consent changes are being reverted, so
// the consent step can't complete on dev/staging and testing is blocked. While
// this is true every AI feature treats consent as given — but never on the
// production host (same `includes('app')` rule as Setting.js), because real
// accounts must still accept the terms. Set to false, or delete this flag and
// the two lines that use it, once the backend is back to normal.
const TEMPORARILY_SKIP_AI_CONSENT = false;

const isProductionHost = () => window.location.hostname.includes('app');

// True once account.consents.aiConsentAcceptedOn holds a real timestamp.
// Guarding the falsy case first matters: moment(undefined) resolves to "now",
// which would read as consent given.
export const isAiConsentAccepted = (accountData) => {
  if (TEMPORARILY_SKIP_AI_CONSENT && !isProductionHost()) {
    return true;
  }
  const acceptedAt = accountData?.consents?.aiConsentAcceptedOn;
  if (!acceptedAt) {
    return false;
  }
  const parsed = moment.utc(acceptedAt);
  // Covers every serialisation of DateTime.MinValue ("0001-01-01T00:00:00",
  // with or without a "Z"/millisecond suffix).
  return parsed.isValid() && parsed.year() > 1;
};
